import { StateCreator } from 'zustand';

export interface YourDetailsSlice {
  firstName: string;
  lastName: string;
  email: string;
  updateFirstName: (firstName: string) => void;
  updateLastName: (lastName: string) => void;
  updateEmail: (email: string) => void;
  resetYourDetails: () => void;
}

export const createYourDetailsSlice: StateCreator<
  YourDetailsSlice,
  [],
  [],
  YourDetailsSlice
> = (set) => ({
  firstName: '',
  lastName: '',
  email: '',
  updateFirstName: (firstName) => set(() => ({ firstName })),
  updateLastName: (lastName) => set(() => ({ lastName })),
  updateEmail: (email) => set(() => ({ email })),
  resetYourDetails: () =>
    set(() => ({
      firstName: '',
      lastName: '',
      email: '',
    })),
});
